const CURSORS = {
  grab: {
    src: "https://www.datocms-assets.com/40484/1745670159-trident-openhand.png",
  },
  grabbing: {
    src:
      "https://www.datocms-assets.com/40484/1745670160-trident-closedhand.png",
  },
};

const setCursor = style => {
  const cursor = CURSORS[style];
  return cursor
    ? `cursor: url(${cursor.src}), ${style} !important;`
    : undefined;
};

export { setCursor };
